import { useEffect, useRef } from 'react';

type UseScreenOrientationChangeOptions = {
  onChange: (options: { type: ScreenOrientation['type'], angle: ScreenOrientation['angle'] }) => void;
}

const useScreenOrientationChange = (options: UseScreenOrientationChangeOptions) => {
  const ref = useRef({
    options,
    debounceTimer: undefined as undefined | NodeJS.Timeout,
    debounceMillis: 50,
    orientation: {
      type: undefined as unknown as ScreenOrientation['type'],
      angle: undefined as unknown as ScreenOrientation['angle'],
    }
  });

  ref.current.options = options;

  const { type, angle } = screen.orientation;
  ref.current.orientation.type = type;
  ref.current.orientation.angle = angle;

  useEffect(() => {

    const debounceOnChange = () => {
      clearTimeout(ref.current.debounceTimer);
      ref.current.debounceTimer = setTimeout(() => {
        const { type, angle } = ref.current.orientation;
        ref.current.options.onChange({ type, angle });
      }, ref.current.debounceMillis);
    };

    const onChange = (event: Event) => {
      const screenOrientation = event.target as unknown as ScreenOrientation;
      const { type, angle } = screenOrientation;
      ref.current.orientation.type = type;
      ref.current.orientation.angle = angle;
      debounceOnChange();
    };
    screen.orientation.addEventListener('change', onChange);

    // call the onChange when first mounting
    debounceOnChange();
    return () => {
      screen.orientation.removeEventListener('change', onChange);
    };
  }, [options]);
};

export { useScreenOrientationChange };
